import { FieldValue, OptionsetValue } from '../../data-objects'
import { OptionSetDirection, OptionsetVisualization } from '../enums'
import { FieldDefinition } from './field-definition'

export class OptionsetFieldDefinition extends FieldDefinition {
  public family: string
  public multipleSelection: boolean
  public visualization: OptionsetVisualization
  public ignoreAlphabeticalOrder: boolean
  public canBeUnselected: boolean
  public direction: OptionSetDirection

  constructor(field?: OptionsetFieldDefinition) {
    super(field)
    this.family = field?.family ?? ''
    this.multipleSelection = field?.multipleSelection ?? false
    this.ignoreAlphabeticalOrder = field?.ignoreAlphabeticalOrder ?? false
    this.canBeUnselected = field?.canBeUnselected ?? true
    this.visualization = field?.visualization ?? OptionsetVisualization.Automatic
    this.direction = field?.direction ?? OptionSetDirection.Horizontal
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getFieldValue(): FieldValue<any> {
    const toReturn = new OptionsetValue()
    toReturn.optionSetName = this.family
    return toReturn
  }
}
